import templateLoader from './utils/templateLoader';

document.querySelectorAll('[data-template]').forEach(templateLoader);
